import { unifiedFilterStore } from "../../../store/unifiedFilters";
import { UnifiedTypeGroups } from "../../../types/filters/unified";
import {
    getInvalidScopeMessage,
    isAccountAgnosticId,
    isScopedToAccount,
    isValidAccount,
} from "../../../utils/permission.utils";
import { ContentUnavailable } from "../../ContentUnavailable";

import { InsightFamiliesViewer } from "./insightFamilies/InsightFamiliesViewer";
import { InsightTemplatesViewer } from "./insightTemplates/InsightTemplatesViewer";
import { UnifiedContentsViewer } from "./unifiedContent/UnifiedContentViewer";

const ContentViewer: React.FunctionComponent<{
    isValid: boolean;
    isScoped: boolean;
    marketingContentId?: string;
}> = ({ isValid, isScoped }) => {
    if (isAccountAgnosticId() || (isScoped && isValid)) {
        if (
            unifiedFilterStore.getState().group === UnifiedTypeGroups.PACKAGED
        ) {
            return <InsightTemplatesViewer />;
        } else if (
            unifiedFilterStore.getState().group === UnifiedTypeGroups.STANDALONE
        ) {
            return <InsightFamiliesViewer />;
        } else {
            return <UnifiedContentsViewer />;
        }
    }

    return <ContentUnavailable message={getInvalidScopeMessage()} />;
};

export const AllInsightsViewer: React.FunctionComponent = () => {
    return (
        <div>
            <ContentViewer
                isValid={isValidAccount()}
                isScoped={isScopedToAccount()}
            />
        </div>
    );
};
